var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "checkout-section" },
    [
      _c(
        "div",
        {
          staticClass:
            "checkout-section__header checkout-section__header--no-line",
        },
        [
          _c("h2", { staticClass: "checkout-section__title" }, [
            _vm._v(_vm._s(_vm.data.travellers.title)),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "checkout-section__description",
            domProps: {
              innerHTML: _vm._s(_vm.data.travellers.descriptionHtml),
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rooms details-container",
          class: {
            "details-containerTs":
              _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
          },
        },
        [
          _c(
            "h3",
            {
              staticClass: "rooms__title details-container__header",
              class: {
                "details-container__headerTs":
                  _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
              },
            },
            [_vm._v("Select Room Types")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rooms__body details-container__body" },
            [
              _c("div", {
                staticClass: "rooms__intro details-container__body-intro",
                domProps: {
                  innerHTML: _vm._s(_vm.data.travellers.introductionHtml),
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.rooms, function (room, index) {
                return _c("Room", {
                  key: room.key,
                  attrs: { room: room, index: index, data: _vm.data },
                })
              }),
              _vm._v(" "),
              _c("div", { staticClass: "rooms__add-room" }, [
                !_vm.exceedPassengerLimit
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: "javascript:void(0)",
                          role: "button",
                          "aria-label": "Add another room",
                          title: "Add another room",
                          disabled: !_vm.canAddRoom,
                        },
                        on: { click: _vm.addRoom },
                      },
                      [_vm._v("Add another room")]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.hasDuplicateName
                ? _c(
                    "div",
                    { staticClass: "error-message rooms__name-error" },
                    [
                      _c("div", { staticClass: "error-message__icon" }),
                      _vm._v(" "),
                      _vm._m(0),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.exceedPassengerLimit
                ? _c("p", { staticClass: "rooms__max-passengers" }, [
                    _vm._v(
                      "\n        Maximum " +
                        _vm._s(_vm.maxPassengers) +
                        " travellers\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      this.donationData.imageUrl != undefined
        ? [
            _c(
              "div",
              {
                staticClass: "rooms details-container",
                class: {
                  "details-containerTs":
                    this.data.brandNameFormatted === _vm.Brand.Travelsphere,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "checkout-step-wrapper",
                    class: {
                      "checkout-step-wrapperTs":
                        this.data.brandNameFormatted === _vm.Brand.Travelsphere,
                    },
                  },
                  [
                    _c("picture", [
                      _c("img", {
                        class: {
                          "checkout-step-image":
                            this.data.brandNameFormatted !==
                            _vm.Brand.Travelsphere,
                        },
                        attrs: {
                          src: `${this.data.donations.image}?format=webp`,
                          alt: this.donationData.name,
                          loading: "lazy",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "container-fluid":
                            this.data.brandNameFormatted !==
                            _vm.Brand.Travelsphere,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              "pb-20":
                                this.data.brandNameFormatted !==
                                _vm.Brand.Travelsphere,
                            },
                          },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(this.data.donations.title),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "personalise__read",
                                class: {
                                  "personalise__read--less": _vm.showFullText,
                                },
                                attrs: {
                                  role: "button",
                                  tabindex: "0",
                                  "aria-expanded": _vm.showFullText,
                                  "aria-label": _vm.showFullText
                                    ? "Read less"
                                    : "Read more",
                                },
                                on: { click: _vm.toggleDescription },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.showFullText
                                        ? "Read less"
                                        : "Read more"
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showFullText
                              ? _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      this.data.donations.descriptionHtml
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("PriceBreakdown"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkout-section__footer" },
        [
          _c("NavButton", {
            class: {
              "btn btn--outline-gray-color btn--outline-gray-color_sm js-modal resultCardMapTs":
                this.data.brandNameFormatted === _vm.Brand.Travelsphere,
            },
            attrs: {
              back: true,
              text: "Back",
              stepBackAmount: _vm.addonSelected ? 1 : 2,
              isFirstPage: !_vm.hasAddons,
            },
          }),
          _vm._v(" "),
          _c("NavButton", {
            attrs: {
              disabled: !_vm.canContinue,
              stepAmount: _vm.excursionsVisited && !_vm.excursionsExist ? 2 : 1,
            },
            on: { beforeNextStep: _vm.setRooms },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "error-message__text" }, [
      _c("p", [_vm._v("You cannot add two passengers with the same name")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }